
import { Routes,Route, useNavigate, useLocation } from 'react-router-dom';
import React, {useState, useEffect} from 'react';
import './App.css';
import { Title } from 'coaz-ui';
import { GlobalContext } from './contexts/GlobalContext';
import { PiArrowsLeftRight, PiUsersLight, PiArrowsLeftRightLight, PiUserLight,PiUsersFourLight, PiUsersThreeLight, PiMaskHappyLight, PiPathLight, PiBankLight,PiSquaresFourLight} from "react-icons/pi";
import {CoazApp} from 'coaz-ui';
import Account from './components/Account';
import Accounts from './components/Accounts';
import ChangePassword from './components/ChangePassword';
import client from './client';
import CriteriaPath from './components/CriteriaPath';
import CriteriaPathItems from './components/CriteriaPathItems';
import Dashboard from './components/Dashboard';
import Deposit from './components/Deposit';
import FinishRegistration from './components/FinishRegistration';
import Login from './components/Login';
import MobilePayment from './components/MobilePayment';
import Payment from './components/Payment';
import PaymentOptions from './components/PaymentOptions';
import Register from './components/Register';
import Role from './components/Role';
import Roles from './components/Roles';
import User from './components/User';
import UserGroups from './components/UserGroups';
import Users from './components/Users';
import UserTypes from './components/UserTypes';
import UserType from './components/UserType';
import Transactions from './components/Transactions';





function App() { 
  const [userFilter,setUserFilter] = useState({});
  const [transactionFilter,setTransactionFilter] = useState({});
  const [loading,setLoading] = useState(false);
  const [version,setVersion] = useState(0);
  const [user,setUser] = useState(null);
  const [menus,setMenus] = useState([]);
  const path = useLocation().pathname;
  const navigate = useNavigate();
  const {getCurrent,logout} = client;

  useEffect(() => { 
    console.log('path',path);
      if(path.includes('_login') || 
        path.includes('_change_password') || 
        path.includes('_register') ||
        path.includes('_finish_registration') ||
        path.includes('_payment') ||
        path.includes('_mobile_payment') ||
        path.includes('_deposit')) return;
      if(path === '/') {
        navigate('/_dashboard');
        return;
      }
      (async () => {
        try {
          const current = await getCurrent();
          if(current && current.user) {
            setUser(current.user);
            let mnus = [];
            mnus.push({name:'Dashboard', link:'/_dashboard', Icon:PiSquaresFourLight});
            mnus.push({name:'My Profile', link:'/_profile', Icon:PiUserLight});
            mnus.push({name:'My Account', link:'/_account', Icon:PiBankLight});
            mnus.push({name:'My Transactions', link:'/_mytransactions', Icon:PiArrowsLeftRightLight});
            
            let settingsMenus = []
            let createUser = current.authorities.find((auth) => {return auth.authority === 'USER:CREATE'});
            let readUser = current.authorities.find((auth) => {return auth.authority === 'USER:READ'});
            let updateUser = current.authorities.find((auth) => {return auth.authority === 'USER:UPDATE'});
            let deleteUser = current.authorities.find((auth) => {return auth.authority === 'USER:DELETE'});

            if(createUser || readUser || updateUser || deleteUser) {
                settingsMenus.push({name:'Users', link:'/_users', Icon:PiUsersLight});
            }

            let createUserType = current.authorities.find((auth) => {return auth.authority === 'USERTYPE:CREATE'});
            let readUserType = current.authorities.find((auth) => {return auth.authority === 'USERTYPE:READ'});
            let updateUserType = current.authorities.find((auth) => {return auth.authority === 'USERTYPE:UPDATE'});
            let deleteUserType = current.authorities.find((auth) => {return auth.authority === 'USERTYPE:DELETE'});

            if(createUserType || readUserType || updateUserType || deleteUserType) {
                settingsMenus.push({name:'User Types', link:'/_usertypes', Icon:PiUsersThreeLight});
            }

            let createUserGroup = current.authorities.find((auth) => {return auth.authority === 'USERGROUP:CREATE'});
            let readUserGroup = current.authorities.find((auth) => {return auth.authority === 'USERGROUP:READ'});
            let updateUserGroup = current.authorities.find((auth) => {return auth.authority === 'USERGROUP:UPDATE'});
            let deleteUserGroup = current.authorities.find((auth) => {return auth.authority === 'USERGROUP:DELETE'});

            if(createUserGroup || readUserGroup || updateUserGroup || deleteUserGroup) {
                settingsMenus.push({name:'User Groups', link:'/_usergroups', Icon:PiUsersFourLight});
            }

            let createRole = current.authorities.find((auth) => {return auth.authority === 'ROLE:CREATE'});
            let readRole = current.authorities.find((auth) => {return auth.authority === 'ROLE:READ'});
            let updateRole = current.authorities.find((auth) => {return auth.authority === 'ROLE:UPDATE'});
            let deleteRole = current.authorities.find((auth) => {return auth.authority === 'ROLE:DELETE'});

            if(createRole || readRole || updateRole || deleteRole) {
                settingsMenus.push({name:'Roles', link:'/_roles', Icon:PiMaskHappyLight});
            }
            
            let createCriteriaPath = current.authorities.find((auth) => {return auth.authority === 'CRITERIA_PATH_ITEM:CREATE'});
            let deleteCriteriaPath = current.authorities.find((auth) => {return auth.authority === 'CRITERIA_PATH_ITEM:DELETE'});
            
            if(createCriteriaPath || deleteCriteriaPath) {
                settingsMenus.push({name:'Criteria Paths', link:'/_paths', Icon:PiPathLight})
            }

            let readAccount = current.authorities.find((auth) => {return auth.authority === 'ACCOUNT:READ'});

            if(readAccount) {
                settingsMenus.push({name:'Accounts', link:'/_accounts', Icon:PiBankLight});
            }

            let readTransaction = current.authorities.find((auth) => {return auth.authority === 'TRANSACTION:READ'});

            if(readTransaction) {
                settingsMenus.push({name:'Transactions', link:'/_transactions', Icon:PiArrowsLeftRight})
            }

            if(settingsMenus.length > 0) {
                for(let menu of settingsMenus) {
                    mnus.push(menu);
                }
            }
            setMenus(mnus);
          }
        } catch(error) {
          console.error('Failed to load navigation menus:', error);
        }
      })()
  },[path]);

  return (
		<div className='flex flex-col bg-[url(/public/images/login.jpg)] bg-cover bg-center w-dvw h-dvh overflow-hidden'>
      <div className='flex w-full h-full overflow-hidden'>
          <GlobalContext.Provider value={{loading,setLoading,
            userFilter,setUserFilter,transactionFilter,setTransactionFilter,version,setVersion}}>
            <Routes>
              <Route path='/' element={<CoazApp 
                title="AUTHENTICATION" 
                menus={menus} 
                user={user} 
                navigate={navigate}
                logoLink="/_dashboard" 
                loginLink={`/_login?successUrl=${window.location.href}`}
                logout={logout}/>}>
                <Route path='_dashboard' element={<Dashboard/>}/>
                <Route path='_profile' element={<User/>}/>
                <Route path='_account' element={<Account/>}/>
                <Route path='_mytransactions' element={<Transactions/>}/>
                <Route path='_users' element={<Users/>}>
                  <Route path='_user/:userId' element={<User/>}/>
                </Route>
                <Route path='_usertypes' element={<UserTypes/>}>
                  <Route path='_usertype/:userTypeId' element={<UserType/>}>
                    <Route path='_role/:roleId' element={<Role/>}/>
                    <Route path='_user/:userId' element={<User/>}/>
                  </Route>
                </Route>
                <Route path='_usergroups' element={<UserGroups/>}/>
                <Route path='_roles' element={<Roles/>}>
                  <Route path='_role/:roleId' element={<Role/>}/>
                </Route>
                <Route path='_paths' element={<CriteriaPathItems/>}>
                  <Route path='_path/:pathId' element={<CriteriaPath/>}/>
                </Route>
                <Route path='_accounts' element={<Accounts/>}>
                  <Route path='_account/:accountId' element={<Account/>}/>
                </Route>
                <Route path='_transactions' element={<Transactions/>}/> 
              </Route>
              <Route path='/_login' element={<Login/>}/>
              <Route path='/_change_password' element={<ChangePassword/>}/>
              <Route path='/_payment_options/:currentUserId/:receivableId/:criteriaId' element={<PaymentOptions/>}/>
              <Route path='/_payment' element={<Payment/>}/>
              <Route path='/_mobile_payment' element={<MobilePayment/>}/>
              <Route path='/_deposit/:userId' element={<Deposit/>}/>
              <Route path='/_register' element={<Register/>}/>
              <Route path='/_finish_registration' element={<FinishRegistration/>}/>
            </Routes>
          </GlobalContext.Provider>
      </div>
    </div>
  )
}

export default App;
